import { getIsMenuOpen } from '@app/ducks';
import { cn } from '@app/utils/cn';
import React from 'react';
import { useSelector } from 'react-redux';

interface Props {
  hasBanner?: boolean;
}

export const HeaderWrapper = ({ hasBanner, children }: React.PropsWithChildren<Props>) => {
  const isMenuOpen = useSelector(getIsMenuOpen);

  return (
    <header
      className={cn('sticky top-0 z-header bg-neutral-96 transition-all', {
        'group-[.scrollingDown]/body:-top-[--headerHeight]': !hasBanner,
        'group-[.scrollingDown]/body:-top-[--headerWithBannerHeight]': hasBanner,
        'z-navMenu': isMenuOpen,
      })}
    >
      {children}
    </header>
  );
};
